export { default } from './ScrollToTopButton';